/** Android cashier app (mobile/kasir): printer, settings and app-only states. */
export const enPos = {
  'pos.nav.settings': 'Settings',
  'pos.live.reconnecting': 'Reconnecting…',
  'pos.live.offlineShort': 'Offline',
  'pos.floor.openHours': 'Open {hours} h {minutes} min',
  'pos.floor.openDays': 'Open {days} d',
  'pos.quick.title': 'Quick sale',
  'pos.quick.subtitle':
    'Tap menu items, take payment and print the receipt — takeaway at the counter.',
  'pos.quick.hint': 'Long-press an item to mark it sold out or available.',
  'pos.quick.cart': 'Cart',
  'pos.quick.empty': 'Tap a menu item to add it.',
  'pos.quick.inCart': '{count} in cart',
  'pos.quick.summary': '{count} items · {total}',
  'pos.quick.viewCart': 'View cart',
  'pos.quick.estimate': 'Estimate. Tax and rounding are added on the bill.',
  'pos.quick.pay': 'Pay {amount}',
  'pos.quick.preparing': 'Preparing the bill…',
  'pos.quick.clear': 'Clear',
  'pos.quick.newSale': 'New sale',
  'pos.quick.locked': 'The order was saved. Retry to continue, or finish it from Orders.',
  'pos.quick.retry': 'Continue checkout',
  'pos.quick.billTitle': 'Payment',
  'pos.quick.availability': 'Availability',
  'pos.quick.add': 'Add',
  'pos.quick.addVariant': 'Add another {name} with its own options',
  'pos.menu.category': 'Category',
  'pos.menu.allCategories': 'All categories',
  'pos.orders.tabOpen': 'Open ({count})',
  'pos.noAccess.title': 'No cashier access',
  'pos.noAccess.text':
    'Your account cannot take payments in any branch. Ask a manager for the cashier role.',
  'pos.settings.title': 'Settings',
  'pos.settings.signedInAs': 'Signed in as {name}',
  'pos.settings.server': 'Server: {url}',
  'pos.settings.version': 'App version {version}',
  'pos.tab.menu': 'Menu',
  'pos.tab.order': 'Order ({count})',
  'pos.tab.bill': 'Bill',
  'pos.printer.title': 'Receipt printer',
  'pos.printer.description':
    'Bluetooth thermal printer. Pair it once in the Android Bluetooth settings, then choose it here.',
  'pos.printer.paired': 'Paired devices',
  'pos.printer.noneFound':
    'No paired devices. Pair the printer in the Android Bluetooth settings, then refresh.',
  'pos.printer.refresh': 'Refresh',
  'pos.printer.selected': 'Selected',
  'pos.printer.current': 'Printer: {name}',
  'pos.printer.none': 'No printer chosen yet.',
  'pos.printer.paper': 'Paper width',
  'pos.printer.paperOption': '{width} mm',
  'pos.printer.drawer': 'Open the cash drawer after a cash payment',
  'pos.printer.autoPrint': 'Print the receipt automatically when a bill is settled',
  'pos.printer.test': 'Print test page',
  'pos.printer.testTitle': 'Printer test',
  'pos.printer.testDone': 'Test page sent to the printer.',
  'pos.printer.forget': 'Remove printer',
  'pos.printer.error.notConfigured': 'Choose a receipt printer first in Settings.',
  'pos.printer.error.unavailable': 'This device has no Bluetooth.',
  'pos.printer.error.off': 'Bluetooth is off. Turn it on and try again.',
  'pos.printer.error.permission': 'Allow "Nearby devices" for apis to use the printer.',
  'pos.printer.error.connect':
    'Could not connect to the printer. Check that it is on, charged and nearby.',
  'pos.printer.error.write': 'Printing was interrupted. Try again.',
  'pos.receipt.print': 'Print receipt',
  'pos.receipt.printing': 'Printing…',
  'pos.receipt.printed': 'Receipt printed.',
  'pos.order.newTakeaway': 'Takeaway',
  'pos.order.newDelivery': 'Delivery',
} as const;
